export default "__VITE_ASSET__DTOPW8WN__"